import { supabase } from './supabase-client';

export async function getUserJwt(override) {
  if (override && typeof override === 'string') return override;

  const urlToken = new URLSearchParams(window.location.search).get('access_token');
  if (urlToken) return urlToken;

  if (supabase) {
    const { data, error } = await supabase.auth.getSession();
    if (error) throw error;
    const token = data?.session?.access_token;
    if (token) return token;
  }
  console.error('client-handshake.js: Failed check. `supabase` is:', supabase);
  throw new Error('No Supabase client available and no ?access_token provided. Initialize Supabase or pass an override.');
}


export async function getSessionInfo(shortCode, devOverrideTime, token) {
  const apiUrl = 'https://api.codemates.fun';
  const qs = new URLSearchParams();
  if (devOverrideTime) qs.set("devOverrideTime", "true");
  
  const fullUrl = `${apiUrl}/session/info/${shortCode}?` + qs.toString();
  
  const res = await fetch(fullUrl, {
    headers: { 
      "Accept": "application/json",
      "Authorization": `Bearer ${token}` 
    }
  });
  
  if (!res.ok) {
    throw new Error(`Session info error: ${res.status} ${res.statusText}`);
  }
  
  return res.json();
}

export async function bootstrapUnitySession({ unityInstance, shortCode, devOverrideTime = false }) {
  const token = await getUserJwt();
  const session = await getSessionInfo(shortCode, devOverrideTime, token);

  const fullPayload = {
    clientType: "client",
    bookingId: session.id,
    socketUrl: "https://client.api.codemates.fun",
    token: token,
    devOverrideTime: !!devOverrideTime,
    sessionInfo: session 
  };
  fullPayload.sessionInfo.socketUrl = "https://client.api.codemates.fun";

  if (window.startSession) {
    window.startSession(fullPayload);
  } else {
    unityInstance.SendMessage("MessageManager", "StartSession", JSON.stringify(fullPayload));
  }

  return session;
}
